import Model from "./Model";
import Patient from './Patient';
import { ClassTransformOptions, plainToClass, Type } from "class-transformer";
import Practitioner from './Practitioner';
import AppointmentRequestStatus from '../enums/AppointmentRequestStatus';

class AppointmentRequest extends Model {

    id: number;
    practitioner_id: number;
    patient_id: number;
    status: AppointmentRequestStatus;
    @Type(() => Date)
    created_at: Date;
    @Type(() => Date)
    updated_at: Date;


    /*
    |--------------------------------------------------------------------------
    | Reflection
    |--------------------------------------------------------------------------
    */

    /**
     * Gets class name
     * survives minification/uglification
     *
     * @return {string}
     */
    getClassName(): string {
        return 'AppointmentRequest';
    }


    /*
    |--------------------------------------------------------------------------
    | Relationships
    |--------------------------------------------------------------------------
    */

    @Type(() => Practitioner)
    practitioner: Practitioner;

    @Type(() => Patient)
    patient: Patient;

    /*
    |--------------------------------------------------------------------------
    | Methods
    |--------------------------------------------------------------------------
    */

    /**
     * Converts plain (literal) object to class (constructor) object. Also works with arrays.
     */
    static new(plain: [], options?: ClassTransformOptions): AppointmentRequest[];
    static new(plain: {}, options?: ClassTransformOptions): AppointmentRequest;
    static new(plain: {} | [], options?: ClassTransformOptions): AppointmentRequest | AppointmentRequest[] {
        return plainToClass(AppointmentRequest, plain as any, options);
    }
}

export default AppointmentRequest;
